import * as React from "react"
import TeamSigil from "./team_sigil"
import { formatLargeNumber } from "../util/goal_utils"

class GoalTag extends React.Component {
    render() {
        const {
            currentAmount,
            goalAmount,
            teamSigil: sigilMeta,
            color,
            name,
            period,
        } = this.props.goal
        const xFactor = currentAmount / goalAmount
        const progressWidth = 218 * xFactor
        const teamSigil = TeamSigil(undefined, sigilMeta)
        const current = formatLargeNumber(currentAmount)
        const goalTotal = formatLargeNumber(goalAmount)

        return (
            <div className="goal-tag">
                <div
                    className="goal-tag-bg"
                    style={{ backgroundColor: color, width: 218 }}
                />
                <div
                    className="goal-tag-progress"
                    style={{
                        backgroundColor: color,
                        width: progressWidth,
                    }}
                />
                <div className="goal-tag-caption">
                    <div className="goal-tag-name">
                        {teamSigil}
                        {name}
                    </div>
                    <div className="goal-stats">
                        <span className="stat-amount">{`${current} / ${goalTotal}`}</span>
                        <span className="stat-text">{period}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default GoalTag



// WEBPACK FOOTER //
// ./src/components/goal_tag.jsx